var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelFillGray1818 = function SvgCancelFillGray1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BBBC",
    d: "M9 .667C4.408.667.667 4.408.667 9S4.408 17.333 9 17.333 17.333 13.592 17.333 9 13.592.667 9 .667m2.8 10.25a.63.63 0 0 1 0 .883.62.62 0 0 1-.442.183.62.62 0 0 1-.442-.183L9 9.883 7.083 11.8a.62.62 0 0 1-.442.183.62.62 0 0 1-.441-.183.63.63 0 0 1 0-.883L8.117 9 6.2 7.083a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0L9 8.117 10.916 6.2a.63.63 0 0 1 .884 0 .63.63 0 0 1 0 .883L9.883 9z"
  })));
};
export default SvgCancelFillGray1818;